import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { useRegistration } from './RegistrationContext';
export const BonusSection = () => {
  const {
    openPopup
  } = useRegistration();
  return <section className="mb-12" data-id="element-86">
      <div className="w-full mb-6" data-id="element-87">
        <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/5cB7x4JBKLA2SGnQ1mna3u/Scherm%C2%ADafbeelding_2025-08-15_om_15.46.41.png" alt="Vrouw wandelt ontspannen met haar hond op een bospad in de namiddagzon" className="w-full h-auto rounded-lg" data-id="element-88" />
        <p className="text-xs text-gray-500 mt-2 text-center italic" data-id="element-89">
          Een stressvrij leven voor je hond. En voor jou.
        </p>
      </div>

      <div className="bg-green-50 border border-green-200 rounded-xl p-8" data-id="element-90">
        <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-91">
          Speciale Bonus Voor Deelnemers:
        </h3>

        <p className="text-gray-800 leading-relaxed mb-6 text-lg" data-id="element-92">
          Als bonus ontvangen deelnemers een speciale verrassing die Amee pas
          tijdens het webinar onthult - iets dat liefdevolle baasjes helpt om
          direct hun hond beter te begrijpen.
        </p>

        <div className="space-y-5 mb-8" data-id="element-93">
          <div className="flex items-start" data-id="element-94">
            <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-95" />
            <span className="text-gray-800 text-lg" data-id="element-96">
              De opname wordt naar alle deelnemers gestuurd
            </span>
          </div>
          <div className="flex items-start" data-id="element-97">
            <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-98" />
            <span className="text-gray-800 text-lg" data-id="element-99">
              Je kunt deelnemen vanaf je telefoon, tablet of computer
            </span>
          </div>
          <div className="flex items-start" data-id="element-100">
            <CheckCircle2Icon className="w-7 h-7 text-green-600 mr-4 mt-0.5 flex-shrink-0" data-id="element-101" />
            <span className="text-gray-800 text-lg" data-id="element-102">
              Speciale verrassingsbonus tijdens het webinar
            </span>
          </div>
        </div>

        <button onClick={openPopup} className="w-full bg-green-700 hover:bg-green-800 text-white font-bold py-4 px-6 rounded-xl transition-colors text-lg" data-id="element-103">
          JA, IK WIL DEZE BONUSSEN - SCHRIJF ME IN!
        </button>
      </div>
    </section>;
};